import type { UniversalSceneNode } from "@/sdk-stub/gtwin-sdk/scene-hierarchy-types";

/**
 * Nodes whose eye toggle represents whole catalog-layer visibility (`visibleIds`
 * / mount gate). Block groups and spatial-index children keep overlay-only
 * visibility so isolation/hide semantics stay local to the subtree.
 */
export function isCatalogLayerVisibilityNode(node: UniversalSceneNode): boolean {
  const meta = node.metadata as Record<string, unknown> | undefined;
  if (meta?.isBlockGroup === true) return false;
  if (meta?.isLayerGroup === true) return Boolean(node.layerId);

  if (node.kind === "asset" && node.layerId) {
    const sceneItemIds = meta?.sceneItemIds;
    if (Array.isArray(sceneItemIds) && sceneItemIds.length > 0) {
      return sceneItemIds.includes(node.layerId);
    }
    // Tier-1 asset bound to a layer without spatial children in the index.
    if (!node.featureId && !meta?.blockCode) return true;
  }

  return false;
}
